import { render, staticRenderFns } from "./Services2.vue?vue&type=template&id=76340526&scoped=true"
import script from "./Services2.vue?vue&type=script&lang=js"
export * from "./Services2.vue?vue&type=script&lang=js"
import style0 from "./Services2.vue?vue&type=style&index=0&id=76340526&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76340526",
  null
  
)

export default component.exports